<div id="wrapper">
    <div id="menu-wrapper">
        <div id="menu" class="container">
            <ul>
                <li class="current_page_item"><a routerLink="/Home">Home</a></li>
                <li><a routerLink="/kunst">Kunst & Cultuur</a></li>
                <li><a routerLink="/zorg">Zorg</a></li>
                <li><a routerLink="/onderwijs">Onderwijs</a></li>
                <li><a routerLink="/contact">Contact</a></li>
            </ul>
        </div>
    </div>
    <div id="banner">
    </div>
    <div id="page" class="container">
    <div id="content">
        <div class="title">
            <h2>WAT WE DOEN</h2>
        </div>
        <p>Auxilium Cu(ltu)ra (afgekort AC) is een onderneming die zich richt op het ontzorgen van organisaties binnen de sectoren Kunst en Cultuur, Onderwijs en de Zorg.</p>
        <p>AC staat voor de combinatie Auxilium Cultura et Cura - “De Cultuur en Zorg Helpen”. 
        Tegenwoordig hebben organisaties veel te maken met professionals die op flexibele basis werken. AC neemt de administratie werkzaamheden voor deze professionals uit handen. Dit geldt zowel voor de opdrachtgever als voor de opdrachtnemer. Van het opstellen van modelovereenkomsten tot volledige facturatie. Daardoor kan iedereen zich richten op waar hij of zij goed in is, en zal het werk effectiever en efficiënter kunnen worden gedaan. Geen energieverlies!</p>
        <div class="title">
            <h2>TARIEVEN</h2>  
        </div>
        <p>Voor alle onderdelen geldt een tariefpercentage van 5% of dat nu bij de opdrachtgever of de opdrachtnemer wordt verrekend. Voor opdrachtgevers geldt een reductie op grotere opdrachten met meer medewerkers. Vanaf een opdrachtsom van €75.000,00 geldt bij elke €25.000,00 aan meerprijs een reductie van 0.5% tot een minimum percentage van 3%</p>
        <div class="title">
            <h2>ONZE FOCUS</h2>
        </div>
        <p><b>Onze focus ligt op de volgende sectoren</b></p>
        <ul style="list-style-type:disc;">
            <li>Onderwijs</li>
            <li>Zorg</li>
            <li>Theater</li>
            <li>Evenementen</li>
            <li>Bouw en metaalbewerking</li>
            <li>(Gast)docenten</li>
            <li>Zorgverleners</li>
            <li>Artiesten en acteurs</li>
            <li>Podium- en Evenemententechnici</li>
            <li>Evenementen</li>
            <li>Specialisten zoals chef-koks, ontwerpers en horecamanagers </li>
            <li>Interim managers voor verandertrajecten en projectmanagement</li>
        </ul> 
        <p><b>Wat wij ontzorgen</b></p>
        <ul style="list-style-type:disc;">
            <li>Factuuradministratie</li>
            <li>Bemiddeling opdrachtnemer en opdrachtgever</li>
            <li>Opstellen van modelovereenkomsten dan wel Overeenkomsten van Opdracht</li>
            <li>Beschikbaar voor alle soorten van ZZP-schap en ondernemerschap</li>
        </ul>
        <p><b>Ontzorgen voor opdrachtnemers</b></p>
        <ul style="list-style-type:square;">
            <li>De opdrachtnemer bepaalt! Wie, wanneer, waar en tegen welke prijs.</li>
            <li>Focus op corebusiness</li>
            <li>Controle op handelen</li>
            <li>Vast aanspreekpunt</li>
        </ul> 
        <p><b>Ontzorgen voor opdrachtgevers</b></p>
        <ul style="list-style-type:square;">
            <li>Overzicht over de inhuur van tijdelijke medewerkers</li>
            <li>Alleen medewerkers op het moment dat deze nodig is</li>
            <li>Geconsolideerde factuur</li>
            <li>Vast aanspreekpunt</li>
            <li>Minder administratie</li>
        </ul> 
        <div class="title">
            <h2>ONZE NAAM</h2>
        </div>
        <p>Auxilium Cu(ltu)ra staat voor de combinatie Auxilium Cultura et Cura - “De Cultuur en Zorg Helpen”. Auxilium Cu(ltu)ra is een samensmelting van de Latijnse woorden Auxilium (helpen), Cultura (cultuur) en Cura (zorg).</p>
        <p>De afkorting LTU staat tussen haakjes omdat deze verwijzen naar de Latijnse woorden: 
        Libertatem (vrijheid), Translatio (overbrengen) en Utilis (nuttig). Deze woorden sluiten naadloos aan bij waar wij als organisatie voor staan.</p>
    </div>
</div>
</div>
<div id="footer-wrapper">
    <div id="footer" class="container">
        <div id="box1">
            <h2>Contact</h2>
            <p>Auxilium Cu(ltu)ra BV, Vliet Noordzijde 49 2231 GP Rijnsburg</p>
            <p>Email: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;info@auxiliumcultura.nl</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 - 53 43 89 00</p>
            <p>Phone: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;06 – 22 50 70 90</p>
        </div>
    </div>
</div>
<div id="copyright-wrapper" class="container">
    <div id="copyright" class="container">
        <p><a routerLink="/copyright">Terms and Conditions</a></p>
    </div>
</div>
